export interface IEquisBreadcrumbTree {
  title: string;
  path?: string;
  children?: IEquisBreadcrumbTree[];
  params?: string;
  active: boolean;
  parentTitle: string;
  id: string;
  parentId: string;
}

export interface IBreadcrumbData {
  parentId: string;
  name: string;
  type: string;
  id: string;
  preloaded?: IEquisBreadcrumbTree[];
}

export interface IContactUsBreadcrumbData {
  path: string;
  title: string;
}

export enum ContactUsTypes {
  CONTACT_CHANNELS = 'contactChannels',
  PHONES = 'phones',
}
